import AppSettings from "lib/services/AppSettings";
import st from "lib/utils/index";
import BaseDecorator from "./BaseDecorator";

@BaseDecorator.translates(["name"])
export default class ProductPricelistItemDecorator extends BaseDecorator {
  static get preset_attributes() {
    return AppSettings.product_pricelist_item_preset_attributes;
  }
  static get presets() {
    return AppSettings.product_pricelist_item_presets;
  }

  static get price_type_options() {
    return [
      ["price_per_item", I18n.humanAttributeName("product_pricelist_item", "price_per_group")],
      ["price_per_person", I18n.humanAttributeName("product_pricelist_item", "price_per_person")],
    ];
  }

  static build(data = {}) {
    return new this({
      id: null,
      uuid: st.generateUuid(),
      translations: [],
      ...data,
    });
  }

  constructor(data) {
    const { min_quantity, max_quantity, ...rest } = data;
    super({
      ...rest,
      min_person_age: data.min_person_age === undefined ? null : data.min_person_age,
      max_person_age: data.max_person_age === undefined ? null : data.max_person_age,
      min_persons_count: data.min_persons_count === undefined ? null : data.min_persons_count,
      max_persons_count: data.max_persons_count === undefined ? null : data.max_persons_count,
      _min_quantity: data._min_quantity !== undefined ? data._min_quantity : (min_quantity === undefined ? null : min_quantity),
      _max_quantity: data._max_quantity !== undefined ? data._max_quantity : (max_quantity === undefined ? null : max_quantity),
    });
    this.normalize();
  }

  normalize() {
    if (this.preset) {
      this.constructor.preset_attributes.forEach((attr) => {
        if (this.isAttributePreset(attr) && this.preset[attr] !== "auto") {
          this[attr] = this.preset[attr] === false ? null : this.preset[attr];
        }
      });
    }
  }

  get display_name() {
    return [this.name, this.age_description ? `(${this.age_description})` : null].filter((x) => !!x).join(" ");
  }

  get age_description() {
    return this.min_person_age || this.max_person_age
      ? I18n.t("base.x_years", {
          count: I18n.formatRange(this.min_person_age, this.max_person_age),
        })
      : null;
  }

  get fits_people() {
    return (
      this.pricelist_type === "pricelist_by_person" ||
      this.min_persons_count !== null ||
      this.max_persons_count !== null
    );
  }

  get min_quantity() {
    switch (this.pricelist_type) {
      case "pricelist_by_order":
        return 1;
      case "pricelist_by_person":
        return this._min_quantity != null ? this._min_quantity : null;
      default:
        return null;
    }
  }

  get max_quantity() {
    switch (this.pricelist_type) {
      case "pricelist_by_order":
        return 1;
      case "pricelist_by_person":
        return this._max_quantity != null ? this._max_quantity : null;
      default:
        return null;
    }
  }

  get pricelist_type() {
    return this.preset && this.preset.pricelist_type;
  }

  get display_name_with_price() {
    const price = this.display_price;
    return price ? `${this.display_name} (${price})` : this.display_name;
  }

  get display_price() {
    return [st.formatMoney(this.price), this.price_label].filter((x) => !!x).join(" ");
  }

  get price_label() {
    if (this.pricelist_type !== "pricelist_by_order") {
      if (this.price_type == "price_per_person") {
        return I18n.t("attributes.x_price_per_person", { x: "" });
      } else if (this.price_type == "price_per_item") {
        return I18n.t("attributes.x_price_per_item", { x: "" });
      }
    }
  }

  get preset() {
    return (
      this.constructor.presets.find((preset) => preset.preset_id === this.preset_id) || {
        price_type: this.price_type,
        persons_count: this.price_type === "price_per_person",
        min_persons_count: "auto",
        max_persons_count: "auto",
        min_person_age: false,
        max_person_age: false,
      }
    );
  }

  get persons_count() {
    if (this.min_persons_count === this.max_persons_count) {
      return this.max_persons_count;
    }
  }

  set persons_count(persons_count) {
    this.min_persons_count = this.max_persons_count = persons_count;
  }

  isAttributePreset(attr) {
    return this.preset && this.preset[attr] != null;
  }

  isAttributeEditable(attr) {
    return this.preset && !this.isAttributePreset(attr);
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductPricelistItemDecorator.js